import * as React from 'react';
import * as main from "../../main.module.scss";
import * as how from "./style.module.scss";
export const How = () => {
  return (
    <section className={how.how}>
      <div className="container">
        <div className={`${how.container} ${main.bg}`}>
          <h2 className={main.title}>Как устроен курс:</h2>
          <ul>
            <li className={how.rus}>
              <h3>Работа с терминами <br/><span>на русском</span></h3>
              <div className={how.textWrap}>
                <p>Вы познакомитесь с основными понятиями в IT сфере и запомните их через видеоуроки, основанные на метафорах.</p>
                <p>Метафоры объединены общей темой, которая ясно и наглядно иллюстрирует смысл изучаемого термина и позволяет легко запомнить его и понять суть.</p>
                <p>После изучения терминов происходит закрепление в формате упражнений.</p>
              </div>
              <p className={how.highlight}>Тестирование для проверки знаний</p>
            </li>
            <li className={how.eng}>
              <h3>Работа с терминами <br/><span>на английском</span></h3>
              <div className={how.textWrap}>
                <p>Изученная лексика переводится на английский язык и запоминается с помощью метода фонетического кодирования.</p>
                <p>Далее следует отработка и закрепление английских слов через такие виды деятельности как «Паттерны на чтение», «Паттерны с заменой» и коммуникативные упражнения.</p>
                <p>Таким образом, каждый урок включает активное применение изучаемого материала, обеспечивая усвоение лексики до автоматизма.</p>
              </div>
              <p className={how.highlight}>Тестирование для проверки знаний</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
